import React from 'react';
import { CalendarDays, CheckCircle2, Database, GraduationCap, LayoutDashboard, ShieldCheck } from 'lucide-react';
import './ProductPreview.css';

function ProductPreview({ compact = false }) {
  return (
    <section className={`product-preview ${compact ? 'product-preview--compact' : ''}`} aria-label="MaiColleges product preview">
      <div className="product-preview__top">
        <div>
          <span className="product-preview__eyebrow">Product preview</span>
          <h2>See the plan before you sign up</h2>
        </div>
        <span className="product-preview__status">3 deadlines soon</span>
      </div>

      <div className="product-preview__grid">
        <article className="product-preview__panel product-preview__panel--wide">
          <div className="product-preview__panel-heading">
            <LayoutDashboard size={16} strokeWidth={1.8} />
            <span>College dashboard</span>
          </div>
          <div className="product-preview__table" aria-hidden="true">
            <div className="product-preview__row product-preview__row--head">
              <span>School</span>
              <span>Fit</span>
              <span>Deadline</span>
            </div>
            <div className="product-preview__row">
              <strong>UCLA</strong>
              <span>Target</span>
              <span>Nov 30</span>
            </div>
            <div className="product-preview__row">
              <strong>Howard</strong>
              <span>Reach</span>
              <span>Feb 15</span>
            </div>
            <div className="product-preview__row">
              <strong>Rutgers</strong>
              <span>Likely</span>
              <span>Dec 1</span>
            </div>
          </div>
        </article>

        <article className="product-preview__panel">
          <div className="product-preview__panel-heading">
            <CalendarDays size={16} strokeWidth={1.8} />
            <span>Up next</span>
          </div>
          <strong className="product-preview__headline">Finish supplements</strong>
          <p>Due Nov 1 for early action schools.</p>
        </article>

        <article className="product-preview__panel">
          <div className="product-preview__panel-heading">
            <CheckCircle2 size={16} strokeWidth={1.8} />
            <span>Progress</span>
          </div>
          <div className="product-preview__checks" aria-hidden="true">
            <span className="is-done">Main essay draft</span>
            <span className="is-done">Teacher recs asked</span>
            <span>FAFSA started</span>
          </div>
        </article>
      </div>

      <div className="product-preview__trust" aria-label="Trust details">
        <span><Database size={14} strokeWidth={1.9} /> College facts use U.S. Department of Education College Scorecard data.</span>
        <span><GraduationCap size={14} strokeWidth={1.9} /> Built for students managing real applications, tasks, essays, and deadlines.</span>
        <span><ShieldCheck size={14} strokeWidth={1.9} /> Your planning data syncs to your signed-in account.</span>
      </div>
    </section>
  );
}

export default ProductPreview;
